import { groupBy } from 'lodash';
import { useEffect, useState } from 'react';
import { existTabItems } from 'pages/globals/global';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
	useGetReportListMutation,
	useGetReportByIdMutation,
	useCreateReportMutation,
	useUpdateReportMutation,
	useReportBulkActiveMutation,
	useReportBulkDeactivateMutation,
} from 'store/features/comptroller/comptrollerApi';

const useReportListView = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();

	const [tabsItem, setTabsItem] = useState([]);
	const [selectedTab, setSelectedTab] = useState(0);
	const [reloadTable, setReloadTable] = useState(false);
	const [reportDataList, setReportDataList] = useState([]);
	const [openCreateModal, setOpenCreateModal] = useState(false);
	const [activeCreateButton, setActiveCreateButton] = useState(true);

	const [getProcessList, { data: processList, isLoading, isSuccess: processListLoad }] = useGetReportListMutation();

	const selectTabHandler = (event, newValue) => {
		setSelectedTab(newValue);

		const tabName = tabsItem?.[newValue]?.label?.toLowerCase()?.replaceAll('-', '');

		navigate(`/comptroller/report?tab=${tabName}`);
	};

	useEffect(() => {
		setActiveCreateButton(isLoading);
	}, [isLoading, reloadTable]);

	useEffect(() => {
		getProcessList({});
	}, [reloadTable]);

	useEffect(() => {
		if (processListLoad) {
			const arr1 = groupBy(processList?.result, 'activationStatus');

			arr1['All'] = processList?.result ?? [];

			const arr2 = Object.keys(arr1);

			const newTabs = existTabItems?.filter((item) => arr2.includes(item.data));

			setTabsItem(newTabs);
			setReportDataList(arr1);
		}
	}, [processListLoad, processList]);

	useEffect(() => {
		const activeTab = searchParams.get('tab');

		if (tabsItem?.length > 0 && activeTab) {
			const index = tabsItem?.findIndex((item) => item?.label?.toLowerCase()?.replaceAll('-', '') === activeTab);

			if (index > -1) setSelectedTab(index);
			else setSelectedTab(0);
		}
	}, [tabsItem]);

	return {
		tabsItem,
		isLoading,
		selectedTab,
		reportDataList,
		setReloadTable,
		openCreateModal,
		selectTabHandler,
		activeCreateButton,
		setOpenCreateModal,
	};
};

export default useReportListView;
